import { BaseEntity } from '../../../app/core';

export class Driver extends BaseEntity {
    id: number;
    name: string;
    lastName: string;
    documentTypeId: number;
    documentNumber: string;
    phone: string;
    cellPhone: string;
    email: string;
    address: string;
    city: string;
    stateId: number;
    postalCode: string;
    sexTypeId: number;
    civilStateId: number;
    nationality: string;
    bornDate: Date = null;
    startInBussiness: Date = null;
    licenseType: string;
    licenseNumber: string;
    licenseCnrt: string;
    licenseExpiration: Date = null;
    driverInjuryId: number;
    file: string;
    creationDate: Date = null;
    isActive: boolean;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/driver.ts